import React from "react";
import styles from "./RealStateHeader.module.scss";
import { ImageBarHeaderProps } from "./RealStateHeader.interface";
import { useWindowSize } from "@/utils/index";

export const ImageBarHeader = (props: ImageBarHeaderProps) => {
	const { imageBar } = props ?? {};
	const anchoAlto = useWindowSize();
	const mobileDevice = () => ((anchoAlto.width as any) ?? 0) <= 767;
	const srcImage = mobileDevice() ? (imageBar?.mobile?.src ?? imageBar.src) : imageBar.src;
	const style = mobileDevice() ? { width: imageBar?.mobile?.width ?? 'unset', height: imageBar?.mobile?.height ?? 'unset' } : { width: imageBar.width ?? 'unset', height: imageBar.height ?? 'unset' };

	if (!imageBar) {
		return <></>;
	}

	const img = (
		<img
			src={`${srcImage}`}
			alt={imageBar.alt ?? 'imagen huincha header'}
			style={style}
		/>
	);

	return (
		<div className={`${styles.cMain} ${styles.imageBarHeader}`} style={{ backgroundColor: imageBar.color ?? '#99FCEA' }}>
			{
				(imageBar.url && imageBar.url !== '') ?
					<a href={`${imageBar.url}`} target='_blank'>
						{img}
					</a> : img
			}
		</div>
	);
};